export const CategoryExclamation = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="white" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="black" />
      <path
        d="M10.4164 12.5003C10.4164 12.2702 10.2298 12.0836 9.99968 12.0836C9.76956 12.0836 9.58301 12.2702 9.58301 12.5003C9.58301 12.7304 9.76956 12.917 9.99968 12.917C10.2298 12.917 10.4164 12.7304 10.4164 12.5003Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4164 10.0003C10.4164 9.77019 10.2298 9.58364 9.99968 9.58364C9.76956 9.58364 9.58301 9.77019 9.58301 10.0003C9.58301 10.2304 9.76956 10.417 9.99968 10.417C10.2298 10.417 10.4164 10.2304 10.4164 10.0003Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4164 7.49983C10.4164 7.2697 10.2298 7.08315 9.99968 7.08315C9.76956 7.08315 9.58301 7.2697 9.58301 7.49983C9.58301 7.72995 9.76956 7.9165 9.99968 7.9165C10.2298 7.9165 10.4164 7.72995 10.4164 7.49983Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
